var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.908 0.554688H3.91677C2.05724 0.554688 0.549805 2.07006 0.549805 3.93936V28.0568C0.549805 29.9261 2.05724 31.4415 3.91677 31.4415H27.908C29.7675 31.4415 31.2749 29.9261 31.2749 28.0568V3.93936C31.2749 2.07006 29.7675 0.554688 27.908 0.554688Z",
    stroke: "#BCD171",
    strokeWidth: 1.73,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0582 10.6866C11.8214 10.2937 10.5005 10.985 10.1097 12.2283C9.94639 12.7455 9.96618 13.2975 10.1641 13.7998L13.6321 22.6175C13.8795 23.264 14.4237 23.7465 15.0916 23.9205C15.7941 24.1045 16.5362 23.9305 17.1249 23.4481L34.9895 8.11537C34.9895 8.11537 34.9944 8.11039 34.9994 8.10542C35.1626 7.97114 35.2368 7.61803 35.0736 7.33456C34.8955 7.01627 34.4947 6.90685 34.1781 7.08589C34.1682 7.09086 34.1534 7.10081 34.1435 7.10578C34.1385 7.10578 34.1336 7.11573 34.1237 7.11573L17.9313 16.8336C17.674 16.9877 17.3426 16.9032 17.1892 16.6446C17.1892 16.6446 17.1892 16.6446 17.1892 16.6396L14.3841 11.7608C14.0922 11.2535 13.6222 10.8706 13.0681 10.6915L13.0582 10.6866Z",
    fill: "#F74542"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickbox);
export default __webpack_public_path__ + "static/media/tickbox.68d9b63f7ba59cb1be7989482bf236cc.svg";
export { ForwardRef as ReactComponent };